// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.created-game-confirmation-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex:1 1;
  /* background-color: rgba(134, 149, 238, 0.53); */
  border-radius: 1%;
  align-items: center;
}

.return-to-dashboard-button {
  background-color: bisque;
  padding: 10px;
  margin-top: 10px;
  border-radius: 5px;
  border:1px;
  border-color: rgba(0, 0, 0, 0.226);
  border-style: solid;
  opacity: .8;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Authenticated/CreatedGameConfirmation/CreatedGameConfirmation.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAM;EACN,iDAAiD;EACjD,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".created-game-confirmation-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex:1;\n  /* background-color: rgba(134, 149, 238, 0.53); */\n  border-radius: 1%;\n  align-items: center;\n}\n\n.return-to-dashboard-button {\n  background-color: bisque;\n  padding: 10px;\n  margin-top: 10px;\n  border-radius: 5px;\n  border:1px;\n  border-color: rgba(0, 0, 0, 0.226);\n  border-style: solid;\n  opacity: .8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
